import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false


//element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


//引入 公共样式
import './common/common.css'

////axios
import axios from 'axios'
import VueAxios from 'vue-axios'



// Vue.use(VueAxios, axios)
// Vue.axios.get(api).then((response) => {
//   console.log(response.data)
// })
 
// this.axios.get(api).then((response) => {
//   console.log(response.data)
// })
 
// this.$http.get(api).then((response) => {
//   console.log(response.data)
// })

//设置 px--> rem 自适应
import 'amfe-flexible';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
